import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getNonSerializableItem } from 'FRONTEND/utils/nonSerializableStorage/index';

// This hook allows to get the current workflow from the non-serializable storage.
// A selector is not allowed because it would depend on stuff that is not in the Redux store.
export const useCurrentWorkflow = () => {
  const storageId = useSelector((state) => state.workflows.storageId);
  return useMemo(() => getNonSerializableItem(storageId), [storageId]);
};
